export default "__VITE_ASSET__4IGrStoa__"